
$('body').on('click', '.campaign-usd .mark-used', function () {
    var $this = $(this);


    loading();
    // check if we are paypal
    var payload = {};

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);

            if (!data.success) {
                unloading();
                showNotice('Error', data.message, 'close');
                return false;
            }

            unloading();
            closeModal();
            showNotice('Success', data.message, 'close');
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });


    return false;
});